import { useEffect, useState, useMemo, Fragment } from "react";
import Link from "next/link";
import { Radio } from "@mui/material";
import style from "./term_and_condition.module.css";

const CONSENT_TEMPLATE_CODE = "DPO-00-01-FM-001 Rev.02";
const ROUTES = {
  DATA_PRIVACY_POLICY: process.env.NEXT_PUBLIC_PRIVACY_NOTICE_URL ?? "https://www.tqm.co.th/tqm/privacy",
};

export function TermAndCondition({ onClose, isModal, setErrorAgree }) {
  const [fiveOne, setFiveOne] = useState(true);
  const [fiveTwo, setFiveTwo] = useState(true);

  const handleChange = async (name, value) => {
    if (name === 51) {
      setFiveOne(value);
    } else if (name === 52) {
      setFiveTwo(value);
    }
  };

  const agreeAll = useMemo(() => {
    if (fiveOne && fiveTwo) return true;
    return false;
  }, [fiveOne, fiveTwo]);

  useEffect(() => {
    setErrorAgree && setErrorAgree(!agreeAll);
  }, [agreeAll]);

  return (
    <Fragment>
      {!isModal && (
        <div
          className={`text-headline7 fixed font-bold w-full z-40 shadow-xs py-6 px-4 pb-4 bg-white rounded-t-xl`}
        >
          <div className="pr-7">เอกสารขอความยินยอม</div>
          <span
            onClick={onClose}
            className="absolute right-4 top-6"
            data-testid="closeTermAndConditionButton"
          >
            <svg
              className="h-6 w-6 text-black"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </span>
        </div>
      )}
      <div
        className={`p-4 tablet:p-6 z-0 relative text-gray-900 ${
          isModal ? "mt-0" : "mt-16 pb-[216px]"
        }`}
      >
        <div className={`${style.descriptionText} ${style.subtitleText}`}>
          หนังสือยินยอมให้เก็บรวบรวมใช้และเปิดเผยข้อมูลส่วนบุคคล
        </div>
        <div className={`${style.descriptionText} ${style.subtitleText}`}>
          บริษัท ทีคิวเอ็ม อินชัวร์รันส์ โบรคเกอร์ จำกัด และ
          บริษัท ทีคิวเอ็ม ไลฟ์ อินชัวร์รันส์ โบรคเกอร์ จำกัด
        </div>
        <div className={`${style.descriptionText} ${style.subtitleText}`}>
          (สำหรับลูกค้าหรือผู้ใช้บริการ)
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (&quot;พ.ร.บ.
          คุ้มครองข้อมูลส่วนบุคคล&quot;) บริษัท ทีคิวเอ็ม อินชัวร์รันส์
          โบรคเกอร์ จำกัด, บริษัท ทีคิวเอ็ม ไลฟ์ อินชัวร์รันส์ โบรคเกอร์ จำกัด
          ซึ่งต่อไปนี้เรียกว่า (“บริษัท”) ในฐานะผู้ควบคุมข้อมูลส่วนบุคคล
          ได้จัดทำนโยบายความเป็นส่วนตัว (Privacy Notice)
          เพื่อแจ้งให้ท่านทราบในฐานะเจ้าของข้อมูลส่วนบุคคล
          ได้ทราบเกี่ยวกับรายละเอียด และวัตถุประสงค์
          รวมถึงรายละเอียดเกี่ยวกับการเปิดเผยข้อมูลส่วนบุคคล
          ระยะเวลาในการจัดเก็บข้อมูลส่วนบุคคลตลอดจนสิทธิ์ตามกฎหมายของ
          ข้าพเจ้าที่เกี่ยวข้องกับข้อมูลส่วนบุคคล
          และวิธีการที่ท่านสามารถติดต่อบริษัทฯ
          เพื่อดำเนินการเกี่ยวกับข้อมูลส่วนบุคคล เพื่อให้สอดคล้องกับ
          พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล ข้าพเจ้าเข้าใจดีว่าบริษัทฯ
          มีความจำเป็นต้องขอความยินยอมในการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าแก่บริษัทฯและ/หรือบุคคลที่ได้รับมอบหมายให้เป็นผู้ประมวลผล
          ข้อมูลส่วนบุคคลจากบริษัทฯ และ/หรือ หน่วยงานของรัฐ และ/หรือ
          หน่วยงานเอกชน และ/หรือบุคคลอื่นใด
          เพื่อปฏิบัติตามกฎหมายดังกล่าวต่อไปนี้
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้าพเจ้าในฐานะเจ้าของข้อมูลส่วนบุคคล
          ได้อ่านและรับทราบนโยบายความเป็นส่วนตัว (
          <Link
            href={ROUTES.DATA_PRIVACY_POLICY}
            target="_blank"
            className="!text-light-blue-500"
          >
            Privacy Notice
          </Link>
          ) ของบริษัทฯ แล้วและขอให้ความยินยอมแก่บริษัทฯ ในการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคล ของข้าพเจ้า
          ที่มีอยู่กับบริษัทได้ภายใต้ข้อกำหนด เงื่อนไข
          นโยบายและวัตถุประสงค์ดังต่อ่ไปนี้
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้อ 1. ข้อมูลที่เก็บรวบรวม ใช้ หรือเปิดเผยโดยบริษัทฯ
          ข้อมูลส่วนบุคคลของเจ้าของข้อมูลส่วนบุคคลที่บริษัทฯ ได้รับมาได้แก่
          <ul className={style.listClass}>
            <li>
              (1) ข้อมูลส่วนบุคคลทั่วไป หมายถึง
              ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุ
              และบ่งบอกตัวบุคคลของเจ้าของข้อมูลส่วนบุคคลนั้นได้ไม่ว่า
              ทางตรงหรือทางอ้อม เช่นชื่อ-นามสกุล วันเดือนปีเกิด อายุ ที่อยู่
              เพศหมายเลขโทรศัพท์ หมายเลขบัตรประชาชน อีเมล ไลน์ไอดี
              ชื่อในการใช้งาน เฟสบุ๊ก (Facebook) หรือ รูปถ่าย เป็นต้น
            </li>
            <li>
              (2) ข้อมูลด้านการทำธุรกิจ หมายถึง ข้อมูล หรือสิ่งใด ๆ ที่แสดง
              ออกมาในรูปแบบเอกสารแฟ้มรายงานหนังสือ การบันทึกภาพนิ่งการบันทึกภาพ
              เคลื่อนไหวหรือเสียงการบันทึกโดยเครื่องมือทางอิเล็กทรอนิกส์
              หรือวิธีอื่นใดที่ทำให้สิ่งที่บันทึกไว้ปรากฏขึ้นในเรื่องที่เกี่ยวกับการ
              ดำเนินธุรกิจของบุคคลที่สามารถระบุตัวบุคคลได้และ/หรือ
            </li>
            <li>
              (3) ข้อมูลส่วนบุคคลที่มีความอ่อนไหวอันได้แก่ข้อมูลชีวภาพ
              ข้อมูลสุขภาพ
              ประวัติอาชญากรรมและข้อมูลที่แสดงอยู่ในเอกสารบัตรประจำตัวประชาชนเป็นต้น
              โดยเป็นข้อมูลส่วนบุคคลที่มีความสมบูรณ์ถูกต้อง
              เป็นปัจจุบันและมีคุณภาพจะถูกนำไปใช้ให้เป็นไปตามวัตถุประสงค์ที่กำหนดไว้ตามหนังสือนี้เท่านั้น
              และบริษัทฯ
              จะดำเนินมาตรการที่เข้มงวดในการรักษาความมั่นคงปลอดภัยตลอดจนการป้องกันมิให้มีการนำข้อมูลส่วนบุคคล
              ไปใช้โดยมิได้รับอนุญาตจากเจ้าของข้อมูลส่วนบุคคลก่อน
            </li>
          </ul>
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้อ 2. ความยินยอมให้เก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคล
          ข้าพเจ้าตกลงยินยอมให้บริษัทฯเก็บรวบรวม ใช้
          และเปิดเผยข้อมูลส่วนบุคคลและข้อมูลการใช้บริการของข้าพเจ้าได้และยินยอมให้บริษัทส่งโอนใช้และ/
          หรือเปิดเผยข้อมูลส่วนบุคคล ให้แก่บุคคลในบริษัทฯ และ/หรือบริษัทฯอื่นๆ
          ในเครือเดียวกัน ผู้ประมวลผลข้อมูลส่วนบุคคล นิติบุคคล หรือบุคคลใด ๆ
          ที่เกี่ยวข้องตามสัญญา คู่ค้า พันธมิตรทางการค้าและธุรกิจ
          ผู้ให้บริการที่เป็นบุคคลภายนอก เช่น ผู้สอบบัญชี ผู้ตรวจสอบภายใน
          ผู้ตรวจสอบภายนอกของบริษัทฯ ที่ปรึกษากฎหมาย ทนายความ
          ผู้ให้บริการเกี่ยวกับเทคโนโลยีสารสนเทศ การวิเคราะห์ ข้อมูล สถิติ การ
          วิจัยและพัฒนาผลิตภัณฑ์ เป็นต้น หรือการดำเนินการตามกฎหมายหน่วยงานภาครัฐ
          หน่วยงานกำกับดูแลสถาบันการเงิน ผู้รับโอน
          สิทธิเรียกร้องทั้งในประเทศและต่างประเทศตามความจำเป็น
          โดยมีวัตถุประสงค์ของการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล คือ
          <ul className={style.listClass}>
            <li>
              (1) เพื่อวัตถุประสงค์ในการประมวลผล การนำเสนอขายผลิตภัณฑ์หรือบริการ
              วิเคราะห์ข้อมูล ปรับปรุงคุณภาพ ผลิตภัณฑ์หรือบริการ
              รวมถึงการบริการภายหลังอันเกี่ยวข้องกับผลิตภัณฑ์หรือบริการ เช่น
              การจัดการข้อเรียกร้อง และ/หรือ ใช้สิทธิ ฯลฯ เป็นต้น
            </li>
            <li>
              (2) เพื่อนําเสนอข้อมูลเกี่ยวกับผลิตภัณฑ์และบริการ
              รวมทั้งเพื่อการปรับปรุง พัฒนา
              และเพื่อคงไว้ซึ่งคุณภาพของผลิตภัณฑ์และบริการ
              ที่เจ้าของข้อมูลส่วนบุคคลเป็นคู่สัญญากับบริษัท
              และเพื่อการติดต่อสื่อสาร ในการดำเนินงานของบริษัทฯ เช่น
              การจัดซื้อจัดจ้าง การทำสัญญา การทำธุรกรรมทางการเงิน
              การดำเนินกิจกรรมบริษัท การติดต่อประสานงาน การโฆษณาประชาสัมพันธ์
              หรือการให้ข้อมูลข่าวสารต่างๆ ฯลฯ เป็นต้น
            </li>
            <li>
              (3) เพื่อปรับปรุงคุณภาพการทำงานให้มีประสิทธิภาพมากยิ่งขึ้นเช่น
              การจัดทำฐานข้อมูล วิเคราะห์และพัฒนากระบวนการดำเนินงานของบริษัท ฯลฯ
              เป็นต้น
            </li>
            <li>(4) เพื่อตรวจสอบรายการที่อาจบ่งชี้ถึงการทุจริต</li>
            <li>
              (5) เพื่อประโยชน์ในการยืนยัน
              หรือระบุตัวตนของเจ้าของข้อมูลส่วนบุคคล
            </li>
            <li>
              (6)
              เพื่อวัตถุประสงค์อื่นใดที่เกี่ยวข้องกับการนำเสนอขายผลิตภัณฑ์หรือบริการระหว่างข้าพเจ้ากับบริษัท
            </li>
            <li>
              (7)
              เพื่อปฏิบัติตามกฎหมายหรือกฎระเบียบของหน่วยงานราชการที่เกี่ยวข้องต่อการดำเนินงานของบริษัทฯ
            </li>
            <li>
              (8) เพื่อวัตถุประสงค์อื่นๆ
              อันจะเกี่ยวข้องระหว่างข้าพเจ้ากับบริษัทในอนาคต
              โดยเป็นไปตามวัตถุประสงค์หรือนโยบายของบริษัท
            </li>
          </ul>
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          โดยบริษัทฯ
          จะจัดเก็บและใช้ข้อมูลดังกล่าวตามระยะเวลาเท่าที่จำเป็นตามวัตถุประสงค์ที่ได้แจ้งให้เจ้าของข้อมูลส่วนบุคคล
          หรือตามที่กฎหมายกำหนดไว้ หรือตามความจำเป็นทางเทคนิคเท่านั้น
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้อ 3.
          ข้าพเจ้ายินยอมให้บริษัทเก็บรวบรวมข้อมูลส่วนบุคคลของข้าพเจ้าจากแหล่งอื่นได้
          เช่น จากส่วนราชการ หรือหน่วยงานของรัฐ
          เก็บข้อมูลของท่านโดยอัตโนมัติผ่านช่องทางต่างๆ
          หรือจากแหล่งข้อมูลสาธารณะ
          ไม่ว่าท่านจะเป็นผู้เปิดเผยข้อมูลส่วนบุคคลด้วยตนเองหรือได้ให้ความยินยอมแก่ผู้ใดในการเปิดเผยข้อมูล
          ส่วนบุคคลของท่านก็ตาม
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้อ 4. วิธีการเพิกถอนความยินยอมและผลการเพิกถอนความยินยอม
          การไม่ให้ความยินยอม
          ข้าพเจ้าในฐานะเจ้าของข้อมูลส่วนบุคคลอาจเพิกถอนความยินยอมทั้งหมดหรือส่วนใดส่วนหนึ่งตามหนังสือฉบับนี้
          โดยข้าพเจ้าจะแจ้งให้บริษัททราบเป็นหนังสือและบริษัทฯอาจขอทราบถึงเหตผุลแห่งการนั้น
          การเพิกถอนความยินยอมของข้าพเจ้าจะไม่ส่งผลกระทบต่อการเก็บรวบรวมใช้หรือเปิดเผย
          ข้อมูลส่วนบุคคลที่ข้าพเจ้าได้ยินยอมแก่บริษัทไปแล้วก่อนหน้านั้น
          ในกรณีที่การเพิกถอนความยินยอมเกิดผลกระทบต่อสิทธิ์ หรือหน้าที่ใด ๆ
          ของข้าพเจ้าข้าพเจ้ายอมรับผลกระทบที่เกิดจากการนั้นแต่เพียงผู้เดียว
          ในกรณีที่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลกำหนดหลักเกณฑ์วิธีการใดๆ
          ในอนาคตที่มีผลทำให้การให้ความยินยอมตามหนังสือฉบับนี้จะต้องเปลี่ยนแปลง
          ปรับปรุง หรือแก้ไข เพี่อให้สอดคล้องกับหลักเกณฑ์และวิธีการดังกล่าว
          ข้าพเจ้ายินดีที่จะให้บริษัทฯ ใช้ความยินยอมเดิมได้
          ข้าพเจ้าในฐานะเจ้าของข้อมูลส่วนบุคคล ยินยอมให้บริษัทฯ จะยังเก็บรวบรวม
          ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านต่อไป
          แม้ว่าท่านจะยุติความสัมพันธ์กับบริษัทฯ
          เท่าที่จำเป็นตามข้อกำหนดของกฎหมาย เพื่อประโยชน์โดยชอบตาม กฎหมาย
          หรือทำการเก็บในรูปแบบที่ทำให้ระบุตัวตนตัวบุคคลไม่ได้
          ไม่ว่าทางตรงหรือทางอ้อม
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          จึงขอยืนยันและให้ความยินยอมสำหรับข้อมูลส่วนบุคคล ดังนี้
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้อ 5.
          ข้อมูลส่วนบุคคลของข้าพเจ้าตามที่ปรากฏในเอกสารและ/หรือระบบอิเล็กทรอนิกส์ทั้งหมดที่ข้าพเจ้าได้ให้ไว้กับบริษัทนี้
          <ul className={style.listClass}>
            <li>
              5.1 ในกิจกรรมการประมวลผล (การเก็บรวบรวม ใช้ หรือเปิดเผย)
              ข้าพเจ้ามีความประสงค์ให้บริษัทฯ ประมวลผล ข้อมูลส่วนบุคคลทั่วไป
              ข้อมูลในการติดต่อสื่อสาร
              ข้อมูลในการนำเสนอขายผลิตภัณฑ์หรือการสินค้าให้บริการ
              ที่เหมาะสมกับวัตถุประสงค์ของข้าพเจ้า (บริษัท
              มีความจำเป็นที่ต้องจัดเก็บตามกฎหมาย ในกรณีที่ท่านไม่ยินยอมในข้อนี้
              บริษัทอาจจะปฏิเสธในการให้บริการกับท่านได้)
              ข้าพเจ้ามีความประสงค์ดังนี้
            </li>
            <li>
              <Radio
                checked={fiveOne}
                value
                name="fiveOne"
                onClick={() => handleChange(51, true)}
                sx={{
                  fontFamily: "IBMPlexSan",
                  color: !fiveOne ? "#D60B0B" : "#C4C4C4",
                  "&.Mui-checked": {
                    color: "#009FDF",
                  },
                }}
              />
              ยินยอม
              <Radio
                checked={!fiveOne}
                value={false}
                name="fiveOne"
                onClick={() => handleChange(51, false)}
                sx={{
                  marginLeft: "16px",
                  fontFamily: "IBMPlexSan",
                  color: !fiveOne ? "#D60B0B" : "#C4C4C4",
                  "&.Mui-checked": {
                    color: !fiveOne ? "#D60B0B" : "#009FDF",
                  },
                }}
              />
              ไม่ยินยอม
            </li>
            <li>
              5.2 เพื่อเป็นการแจ้งข่าวสาร โปรโมชั่น
              ประชาสัมพันธ์และสิทธิพิเศษผลิตภัณฑ์ของทางบริษัท
              ตลอดจนเพื่อการปรับปรุง พัฒนา
              และเพื่อคงไว้ซึ่งคุณภาพของผลิตภัณฑ์และบริการ
              ไม่ว่าจะเป็นคู่สัญญากับบริษัท หรือยุติความสัมพันธ์กับบริษัทฯ
              ไปแล้วก็ตาม ( สิทธิประโยชน์ของท่านในการทราบข้อมูลดังกล่าว
              ในกรณีที่ท่านไม่ยินยอมในข้อนี้
              ท่านอาจจะไม่ได้รับสิทธิพิเศษดังกล่าวได้)
            </li>
            <li>
              <Radio
                checked={fiveTwo}
                value
                name="fiveTwo"
                onClick={() => handleChange(52, true)}
                sx={{
                  fontFamily: "IBMPlexSan",
                  color: !fiveTwo ? "#D60B0B" : "#C4C4C4",
                  "&.Mui-checked": {
                    color: "#009FDF",
                  },
                }}
              />
              ยินยอม
              <Radio
                checked={!fiveTwo}
                value={false}
                name="fiveTwo"
                onClick={() => handleChange(52, false)}
                sx={{
                  marginLeft: "16px",
                  fontFamily: "IBMPlexSan",
                  color: !fiveTwo ? "#D60B0B" : "#C4C4C4",
                  "&.Mui-checked": {
                    color: !fiveTwo ? "#D60B0B" : "#009FDF",
                  },
                }}
              />
              ไม่ยินยอม
            </li>
          </ul>
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้อ 6. ข้าพเจ้าเข้าใจเป็นอย่างดีว่าข้อมูลส่วนบุคคลของข้าพเจ้าที่บริษัท
          จะดำเนินการประมวลผลเพื่อวัตถุประสงค์ตามนโยบายที่บริษัทกำหนด
          มีความเกี่ยวเนื่องกับการปฏิบัติตามกฎหมาย
          เป็นข้อมูลที่จำเป็นต่อการบรรลุวัตถุประสงค์ดังกล่าว
          หากข้าพเจ้าไม่ประสงค์ที่จะให้ข้อมูลส่วนบุคคลดังกล่าวแก่บริษัทฯ
          อาจมีผลกระทบทางกฎหมาย หรืออาจทำให้บริษัทฯ
          ไม่สามารถปฏิบัติตามนโยบายการให้บริการได้ ในกรณีดังกล่าว
          ข้าพเจ้ายินยอมให้บริษัทฯ ปฏิเสธการให้บริการ
          หรือสิทธิประโยชน์ที่เกี่ยวข้องอื่นใด ไม่ว่าทั้งหมดหรือบางส่วน
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้อ 7.
          ความรับผิดชอบในข้อมูลส่วนบุคคลของบุคคลอื่นที่ข้าพเจ้านำมาอ้างอิงในการใช้บริการหรือเอกสารประกอบ
          ถือว่าเป็นความรับผิดชอบของข้าพเจ้าที่จะต้องขอความยินยอมจากบุคคลที่ข้าพเจ้านำมาอ้างอิง
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้อ 8. ผู้ใช้บริการสามารถเพิกถอนความยินยอมแก่บริษัทฯ ในการเก็บรวบรวม
          ใช้หรือเปิดเผย ข้อมูลส่วนบุคคล
          โดยแจ้งให้ทางบริษัททราบผ่านช่องทางการติดต่อด้านล่าง
          โดยการเพิกถอนคำยินยอมนี้ จะไม่ส่งผลต่อการเก็บรวบรวม ใช้หรือเปิดเผย
          ข้อมูลส่วนบุคคลที่ได้ให้ความยินยอมก่อนหน้า
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้อ 9. ข้าพเจ้า ยินยอมให้ บริษัทฯ อาจเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า
          ในกรณีจำเป็นอื่นๆ เช่น การปฏิบัติเพื่อให้สอดคล้องกับกฎหมายที่ใช้บังคับ
          การปฏิบัติตามคำร้องขอจากหน่วยงานรัฐบาลหรือหน่วยงานของรัฐ
          หรือเพื่อการประสานงานกับหน่วยงานต่างๆ
          ในเรื่องที่เกี่ยวข้องกับการปฏิบัติตามกฎหมาย
          การตอบสนองต่อความปลอดภัยของบุคคลหรือสาธารณะ การพิจารณาคดี การดำเนินคดี
          การสืบสวน สอบสวน และเรื่องทางกฎหมายอื่นๆ
          ที่มีข้อมูลส่วนบุคคลเข้ามาเกี่ยวข้อง
          การตรวจสอบเหตุการณ์ด้านความปลอดภัย
          การบังคับใช้ข้อกำหนดในการให้บริการของบริษัทฯ เป็นต้น
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้อ 10. นอกจากวัตถุประสงค์ดังกล่าวข้างต้นและภายใต้ข้อกำหนดของกฎหมาย
          ข้าพเจ้ายินยอมให้บริษัทฯ อาจจะใช้ข้อมูลส่วนบุคคลของท่าน เช่น
          ชื่อ-นามสกุล และข้อมูลการติดต่อของท่าน เพื่อวัตถุประสงค์ทางการตลาด
          เช่น การส่งเนื้อหา (ทางไปรษณีย์ อีเมล โทรศัพท์
          และ/หรือด้วยวิธีการอื่นๆ)
          เพื่อเพิ่มสิทธิประโยชน์ที่ท่านจะได้รับจากการเป็นลูกค้าของบริษัทฯ
          ผ่านการแนะนำของผลิตภัณฑ์และบริการที่เกี่ยวข้อง การประชาสัมพันธ์
          การส่งเสริมการขายและการสื่อสารการตลาดทางตรงเกี่ยวกับผลิตภัณฑ์และ/หรือบริการของเรา
          ข้อมูลทางการตลาด คำแนะนำและข้อมูลในเรื่องต่างๆ
          โดยในการดำเนินการดังกล่าวนี้ บริษัทฯ
          อาจต้องเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่บุคลากรและพันธมิตรทางธุรกิจของบริษัทฯ
          เพื่อการดำเนินการใดๆ เพื่อให้บริษัทฯบรรลุวัตถุประสงค์
        </div>
        <div className={`${style.descriptionText} ${style.indentText}`}>
          ข้อ 11. สามารถติดต่อบริษัทฯ ผ่านช่องทาง ดังนี้
        </div>
        <div className={`${style.descriptionText} ${style.indentText} indent-12`}>
          บริษัท ทีคิวเอ็ม อินชัวร์รันส์ โบรคเกอร์ จำกัด
        </div>
        <div className={`${style.descriptionText} ${style.indentText} indent-16`}>
          ที่อยู่ : เลขที่ 123 ถนนลาดปลาเค้า แขวงจรเข้บัว เขตลาดพร้าว กรุงเทพฯ
          10230
        </div>
        <div className={`${style.descriptionText} ${style.indentText} indent-12`}>
          บริษัท ทีคิวเอ็ม ไลฟ์ อินชัวร์รันส์ โบรคเกอร์ จำกัด
        </div>
        <div className={`${style.descriptionText} ${style.indentText} indent-16`}>
          ที่อยู่ : เลขที่ 123/3 ถนนลาดปลาเค้า แขวงจรเข้บัว เขตลาดพร้าว กรุงเทพฯ
          10230
        </div>
        <div className={`${style.descriptionText} ${style.indentText} indent-12`}>
          เบอร์โทรศัพท์ : 02-119-8537 ฝ่ายลูกค้าสัมพันธ์
        </div>
        <div className={`${style.descriptionText} ${style.indentText} indent-12`}>
          Email:&nbsp;
          <a href="mailto:dpo@tqm.co.th" className="!text-light-blue-500">
            dpo@tqm.co.th
          </a>
        </div>
        <div className="text-button-small my-1 font-semibold">
          {CONSENT_TEMPLATE_CODE}
        </div>
      </div>
    </Fragment>
  );
}
